import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "../helper/axios";
import { signedProductTotal } from "../helper/orderTotals";
import QRCode from "react-qr-code";
import Pdf from "react-to-pdf";
import "./style.css";

export default function Invoice({ refreshToken = 0 }) {
  const { id } = useParams();
  const ref = useRef();

  const [invoiceData, setInvoiceData] = useState([]);
  const [vatData, setVatData] = useState(0);

  const printOrder = () => {
    window.open(`/print-order/${id}?t=${Date.now()}`, "_blank");
  };

  /* ---------------- API ---------------- */
  const apiData = async () => {
    const res = await axios.post("/getinvoice", { id });
    if (res.status === 200) setInvoiceData(res.data);
  };

  const vatGetData = async () => {
    const res = await axios.post("/getvatupdate");
    if (res.status === 200) {
      setVatData(Number(res?.data[0]?.vatData || 0));
    }
  };

  useEffect(() => {
    vatGetData();
  }, []);

  useEffect(() => {
    if (!id) return;
    apiData();
  }, [id, refreshToken]);

  if (!invoiceData || invoiceData.length === 0) return null;

  const order = invoiceData[0];
  const activeProducts = (order.productList || []).filter((p) => p?.includeItem !== false);

  const shippingMethodLabel =
    order.shippingMethod === "boxes" ? "BOXES" : "STANDARD";

  const orderCreatedLabel =
    order.createdAt != null
      ? new Date(order.createdAt).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
      : null;

  /* ---------------- CALCULATIONS ---------------- */
  var sum = 0;
  console.log(invoiceData);
  invoiceData?.forEach((dt) => {
    for (let key in dt?.productList) {
      const item = dt?.productList[key];
      if (item?.includeItem !== false) {
        sum = sum + signedProductTotal(item);
      }
    }
  });

  // Use deliverMode directly from database (already calculated based on orderTotal)
  const shipping = invoiceData[0]?.deliverMode || 0;

  const grandTotal =
    parseFloat(sum.toFixed(2)) + parseFloat(shipping.toFixed(2));

  // Function to render a single invoice copy
  const renderInvoiceCopy = (copyLabel) => (
    <div className="invoice-copy" style={{ width: '100%', marginBottom: '30px', pageBreakAfter: 'always' }}>
      <div className="invoice-header">
        <div>
          <p>Veternik 10000 Prishtina, Kosovë</p>
          <p>www.albi.com | Tel: +383 (0) 48 300 800</p>
        </div>
        <img
          src={process.env.PUBLIC_URL + "/dist/img/logo.jpg"}
          alt="logo"
          width="120"
        />
      </div>

      {/* INFO SECTIONS */}
      <div className="invoice-sections">
        <div className="section-box">
          <h6 className="section-title">
            DËRGESA :{" "}
            <span className="shipping-method-label">{shippingMethodLabel}</span>
          </h6>
          <p>
            <b>Emri : </b> {order.fname}
          </p>
          <p>
            <b>Mbiemri : </b> {order.lname}
          </p>
          <p>
            <b>Adresa : </b> {order.address}
          </p>
          <p>
            <b>Qyteti : </b> {order.city}
          </p>
          <p>
            <b>Shteti : </b> Kosovë
          </p>
          <p>
            <b>Telefoni : </b> {order.phoneNumber}
          </p>
        </div>

        <div className="section-box">
          <h6 className="section-title">POROSIA</h6>
          <p>Porosia nuk lejohet të hapet gjatë pranimit</p>
        </div>
      </div>

      {/* PRODUCT TABLE */}
      <table className="product-table">
        <thead>
          <tr>
            <th className="col-num">#</th>
            <th className="col-product">Produkti</th>
            <th className="col-store">Dyqani</th>
            <th className="col-qty">Sasia</th>
            <th className="col-price">Çmimi</th>
          </tr>
        </thead>
        <tbody>
          {activeProducts.map((p, i) => (
            <tr key={i}>
              <td className="col-num">{i + 1}</td>
              <td className="col-product">
                {p.name} <span>-</span> ({p.size})
              </td>
              <td className="col-store">{p.storeName || ""}</td>
              <td className="col-qty">{p.quantity}</td>
              <td className="col-price">
                {signedProductTotal(p).toFixed(2)} {process.env.REACT_APP_CURRENCY}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* FOOTER */}
      <div className="invoice-footer">
        <div className="qr-section">
         
          <p>#{order.orderId?.split("-").slice(0, -1).join("-")}</p>
          <QRCode
            size={130}
            value={order.orderId?.split("-").slice(0, -1).join("-")}
          />
          {orderCreatedLabel ? (
            <p style={{ marginTop: "6px", fontSize: "11px" }}>
              Data e Porosise : {orderCreatedLabel}
            </p>
          ) : null}
        </div>

        <div className="total-box">
          <p>
            <span>Nëntotali</span>
            <span>
              {sum.toFixed(2)} {process.env.REACT_APP_CURRENCY}
            </span>
          </p>

          <p>
            <span>Transporti</span>
            <span>
              {shipping.toFixed(2)} {process.env.REACT_APP_CURRENCY}
            </span>
          </p>

          <p className="grand-total">
            <span>Totali</span>
            <span>
              {grandTotal.toFixed(2)} {process.env.REACT_APP_CURRENCY}
            </span>
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="modal fade" id="modal-default">
      <div className="modal-dialog modal-lg">
        <div className="modal-content invoice-content">
          <div className="modal-body invoice-modal" ref={ref}>
            {/* First Invoice - Full Width */}
            {renderInvoiceCopy("Kopje për Klientin")}

            {/* Second Invoice - Full Width */}
            {renderInvoiceCopy("Kopje për Ne")}

            {/* Signature Section */}
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              marginTop: '40px',
              paddingTop: '20px',
              borderTop: '1px solid #ddd',
              width: '100%'
            }}>
              {/* Left side - Dorezoi */}
              <div style={{ width: '30%' }}>
                <p style={{ marginBottom: '40px', fontWeight: 'bold' }}>
                  Dorezoi (Emri, Mbiemri, Nenshkrimi)
                </p>
                <div style={{ 
                  borderTop: '1px solid #000', 
                  width: '100%',
                  marginTop: '10px'
                }}></div>
              </div>

              {/* Right side - Pranoi and Dorezoi */}
              <div style={{ width: '30%' }}>
                <p style={{ marginBottom: '40px', fontWeight: 'bold' }}>
                      Pranoi(Emri, Mbiemri, Nenshkrimi)
                </p>
                <div style={{ 
                  borderTop: '1px solid #000', 
                  width: '100%',
                  marginBottom: '10'
                }}></div>
              
              </div>
            </div>
          </div>

          {/* ACTIONS */}
          <div className="modal-footer">
            <button className="btn btn-secondary" data-dismiss="modal">
              Cancel
            </button>

            <Pdf
              targetRef={ref}
              filename="invoice.pdf"
              options={{
                orientation: "portrait",
                unit: "in",
                format: "a4"
              }}
              scale={0.8}
            >
              {({ toPdf }) => (
                <button className="btn btn-warning" onClick={toPdf}>
                  Download
                </button>
              )}
            </Pdf>

            <button className="btn btn-primary" onClick={printOrder}>
              Print
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
